export const projects = [
    {
        "pkey": "TEST-PROJECT-PCLGTZNS-P1", //test Project
        "pname": 'test',
        "cname": 'test',
        'ckey': "TEST-COMPANY-PCLGTZNS",
        "banner": "/media/images/repay_banner.png",
        "logo": "/media/images/inn_logo.png",
        'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/mitr-3.png",
        "login_tag_line": "Enter your registered mobile number to login.",
        "login_bg_image": "/media/images/mitr-spalsh.jpg",
        "add_to_cart": true,
        "login_terms_condition": true,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'CommonDashboard',
        'sidemenu': true,
        "scheme_banner": '/media/images/repay_scheme.jpg',
        "uavtar_bg": '/media/images/u-avtar-bg.png',
        "dashboard_backurl": '',
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': true,
        "scheme_dashboard": true,
        "trem_condition": true,
        "login_screen": true,
        "redemption_end_date": "2026-06-28 11:59:59",

    },
    // {
    //     "pkey": "P-IIRPL-F9PWSX8H", //MITR
    //     "pname": 'mitr',
    //     'ckey': "C-IIRPL-CAMQPK38",
    //     "cname": 'mitr',
    //     "banner": "/media/images/mitr-banner3.png",
    //     "logo": "/media/images/mitr_logo.png",
    //     'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
    //     'welcome_image': "/media/images/mitr-3.png",
    //     "login_tag_line": "Enter your registered mobile number to login.",
    //     "login_bg_image": "/media/images/mitr-spalsh.jpg",
    //     "add_to_cart": true,
    //     "login_terms_condition": true,
    //     "category": false,
    //     "welcome_pupop": true,
    //     "dashboardName": 'CommonDashboard',
    //     'sidemenu': true,
    //     "dashboard_backurl": '',
    //     "special_message": 'Redemption open till 26 December, 11:59 PM',
    //     "project_text": 'Click here to view the scheme.',
    //     "purchase_banner": '',
    //     'redemnessDashboard': false,
    //     "scheme_dashboard": false,
    //     "trem_condition": false,
    //     "login_screen": true,
    //     "redemption_end_date": "2026-06-28 11:59:59",
    // },
    {
        "pkey": "P-IIRPL-CEBPUAXF", // cortiva
        'ckey': "C-IIRPL-HFBB4B7B",
        "pname": 'tracer',
        "cname": 'corteva',
        "banner": "/media/images/cortieva-banner.jpg",
        "logo": "/media/images/CortevaLegal_HorColor_RGB_no_tagline.webp",
        'logo_class': "mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/cortieva-banner.jpg",
        "login_tag_line": "Enter your registered mobile number to sign in and upload your KYC documents.",
        "login_bg_image": "/media/images/corteva-splash.png",
        "kyc_bank_enable": 1,
        "kyc_pan_enable": 1,
        "kyc_upi_enable": 2,
        "add_to_cart": false,
        "login_terms_condition": false,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'CortevaDashboard',
        'sidemenu': false,
        "product_name": 'Tracer Green Cashback',
        "product_img": 'cust.jpg',
        "dashboard_backurl": '/customer/scheme-dashboard',
        "scheme_banner": '/media/images/corteva_banner_tacer.png',
        "special_message": '',
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': false,
        "scheme_dashboard": true,
        "trem_condition": true,
        "login_screen": true,
        "redemption_end_date": "2026-06-28 11:59:59",
    },

    {
        "pkey": "P-IIRPL-RVEFWY6L", // cortiva galileo cumin
        'ckey': "C-IIRPL-HFBB4B7B",
        "pname": 'corteva-galileo',
        "cname": 'corteva',
        "banner": "/media/images/corteva-galileo-cumin.png",
        "logo": "/media/images/CortevaLegal_HorColor_RGB_no_tagline.webp",
        'logo_class': "mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/corteva-galileo-cumin.png",
        "login_tag_line": "Enter your registered mobile number to sign in and upload your KYC documents.",
        "login_bg_image": "/media/images/corteva-splash.png",
        "kyc_bank_enable": 1,
        "kyc_pan_enable": 1,
        "kyc_upi_enable": 2,
        "add_to_cart": false,
        "login_terms_condition": false,
        "welcome_pupop": false,
        "category": false,
        "dashboardName": 'CortevaGalileoDashboard',
        'sidemenu': false,
        "product_name": 'Galileo Cumin Retailer Cashback',
        "product_img": 'corteva-galieo-product.png',
        "dashboard_backurl": '/customer/scheme-dashboard',
        "scheme_banner": '/media/images/corteva_banner_galileo.png',
        "special_message": '',
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": 'chashBack13.png',
        'redemnessDashboard': false,
        "scheme_dashboard": true,
        "trem_condition": true,
        "login_screen": true,
        "redemption_end_date": "2026-06-28 11:59:59",
    },
    {
        "pkey": "cortevea_lucky_draw", // cortiva galileo cumin
        'ckey': "C-IIRPL-HFBB4B7B",
        "pname": 'cortevea_lucky_draw',
        "cname": 'corteva',
        "banner": "/media/images/corteva-galileo-cumin.png",
        "logo": "/media/images/CortevaLegal_HorColor_RGB_no_tagline.webp",
        'logo_class': "mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/corteva-galileo-cumin.png",
        "login_tag_line": "Enter your registered mobile number to sign in and upload your KYC documents.",
        "login_bg_image": "/media/images/corteva-splash.png",
        "kyc_bank_enable": 1,
        "kyc_pan_enable": 1,
        "kyc_upi_enable": 2,
        "add_to_cart": false,
        "login_terms_condition": false,
        "welcome_pupop": false,
        "category": false,
        "dashboardName": 'LuckyDrawDashboard',
        'sidemenu': false,
        "product_name": 'Galileo Cumin Retailer Cashback',
        "product_img": 'corteva-galieo-product.png',
        "dashboard_backurl": '/customer/scheme-dashboard',
        "scheme_banner": '/media/images/lucky.png',
        "special_message": 'Lucky Draw',
        "project_text": 'Click here to view the coupon code.',
        "purchase_banner": '',
        'redemnessDashboard': false,
        "scheme_dashboard": true,
        "trem_condition": true,
        "login_screen": true,
        "redemption_end_date": "2026-06-28 11:59:59",
    },
    {
        "pkey": "P-IIRPL-VNPGFSQX", // DELEGATE & TRACER GREEN
        'ckey': "C-IIRPL-HFBB4B7B",
        "pname": 'cortevea_delegate',
        "cname": 'corteva',
        "banner": "/media/images/delegate-tracer.png",
        "logo": "/media/images/CortevaLegal_HorColor_RGB_no_tagline.webp",
        'logo_class': "mx-auto w-200px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/corteva-galileo-cumin.png",
        "login_tag_line": "Enter your registered mobile number to sign in and upload your KYC documents.",
        "login_bg_image": "/media/images/corteva-splash.png",
        "kyc_bank_enable": 1,
        "kyc_pan_enable": 1,
        "kyc_upi_enable": 2,
        "add_to_cart": false,
        "login_terms_condition": false,
        "welcome_pupop": false,
        "category": false,
        "dashboardName": 'CortevaGalileoDashboard',
        'sidemenu': false,
        "product_name": 'DELEGATE & TRACER GREEN',
        "product_img": 'DELEGATE-TRACERGREEN.jpg',
        "dashboard_backurl": '/customer/scheme-dashboard',
        "scheme_banner": '/media/images/delegate-tracer.png',
        "special_message": 'Lucky Draw',
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": 'deleagte-purchase.jpg',
        'redemnessDashboard': false,
        "scheme_dashboard": true,
        "trem_condition": true,
        "login_screen": true,
    },

    {
        "pkey": "IIRPL-greenply-QDGKM-P1", //  GREEN_PLYs
        'ckey': "IIRPL-greenply-QDGKM",
        "pname": 'greenply',
        "cname": 'greenply',
        "banner": "/media/images/green-ply-banner.png",
        "logo": "/media/images/greenply-logo.png",
        'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/mitr-3.png",
        "login_tag_line": "Enter your registered mobile number to login.",
        "login_bg_image": "/media/images/mitr-spalsh.jpg",
        "add_to_cart": true,
        "login_terms_condition": true,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'GreenplyDashboard',
        'sidemenu': true,
        "dashboard_backurl": '',
        "special_message": '', //Redemption open till 26 December, 11:59 PM
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': false,
        "scheme_dashboard": false,
        "trem_condition": true,
        "web_link": true,
        "login_screen": false,
        "redemption_end_date": "2026-06-28 11:59:59",
    },

    {
        "pkey": "P-IIRPL-N6WPJF3C", //  indoasian
        'ckey': "C-IIRPL-UDKV7R4S",
        "pname": 'indoasian',
        "cname": 'indoasian',
        "banner": "/media/logos/indoasian-banner-1.png",
        "logo": "/media/logos/indo-saving-connection.png",
        'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/mitr-3.png",
        "login_tag_line": "Enter your registered mobile number to login.",
        "login_bg_image": "/media/images/indoasian-spalsh.jpg",
        "add_to_cart": true,
        "login_terms_condition": true,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'IndoasianDashboard',
        'sidemenu': true,
        "dashboard_backurl": '',
        "special_message": '', //Redemption open till 26 December, 11:59 PM
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': false,
        "scheme_dashboard": false,
        "trem_condition": true,
        "web_link": true,
        "login_screen": true,
        "redemption_end_date": "2026-06-28 11:59:59",
    },

    {
        "pkey": "P-IIRPL-6CN8YCXR", //  fmc aksya patrara  on dev
        'ckey': "C-IIRPL-KDYZH97N",
        "pname": 'fmc_aksya_patrara',
        "cname": 'fmc',
        "banner": "/media/images/akp6_banner.jpg",
        "logo": "/media/images/fmc-1973.svg",
        'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/mitr-3.png",
        "login_tag_line": "Enter your registered mobile number to login.",
        "login_bg_image": "/media/images/mitr-spalsh.jpg",
        "add_to_cart": true,
        "login_terms_condition": true,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'FmcAksyaPatraraDashboard',
        'sidemenu': true,
        "dashboard_backurl": '',
        "special_message": '', //Redemption open till 26 December, 11:59 PM
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': false,
        "scheme_dashboard": true,
        "trem_condition": true,
        "web_link": true,
        "login_screen": false,
        "redemption_end_date": "2026-06-28 11:59:59",
    },

    {
        "pkey": "IIRPL-kyc-redemness-P1", //  Kyc redemness
        'ckey': "IIRPL-kyc-redemness",
        "pname": 'kyc',
        "cname": 'kyc',
        "banner": "/media/images/green-ply-banner.png",
        "logo": "/media/images/greenply-logo.png",
        'logo_class': "mx-auto w-100px w-md-50 w-xl-200px mb-1 mb-lg-10",
        'welcome_image': "/media/images/mitr-3.png",
        "login_tag_line": "Enter your registered mobile number to login.",
        "login_bg_image": "/media/images/mitr-spalsh.jpg",
        "add_to_cart": false,
        "login_terms_condition": true,
        "category": false,
        "welcome_pupop": false,
        "dashboardName": 'KycWithoutLoginDashboard',
        'sidemenu': false,
        "dashboard_backurl": '',
        "special_message": '', //Redemption open till 26 December, 11:59 PM
        "project_text": 'Click here to view the scheme.',
        "purchase_banner": '',
        'redemnessDashboard': true,
        "scheme_dashboard": false,
        "trem_condition": false,
        "web_link": true,
        "login_screen": false,
        "redemption_end_date": "2026-06-28 11:59:59",
    },
]